import { Reducer } from 'redux';
import { IDivorceFilesDetails, IDivorcesState } from 'types/divorces.types';
import * as authConstants from '../constants/auth.constants';
import * as constants from '../constants/divorces.constants';

export const defaultState: IDivorcesState = {
  count: 0,
  idCardTypes: {},
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'id',
    sortType: 'asc',
  },
};

const divorcesReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.DIVORCES_ON_DELETE_REQUESTED:
    case constants.DIVORCES_ON_DELETE_FILE_REQUESTED:
    case constants.DIVORCES_ON_GET_ALL_REQUESTED:
    case constants.DIVORCES_ON_GET_FORM_REQUESTED:
    case constants.DIVORCES_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.DIVORCES_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.DIVORCES_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.DIVORCES_ON_GET_FORM_SUCCEEDED:
      return {
        ...state,
        idCardTypes: data.idCardTypes,
        loading: false,
      };
    case constants.DIVORCES_ON_DELETE_FILE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: {
          ...state.selectedItem,
          files: state.selectedItem.files.filter(
            (file: IDivorceFilesDetails) => file.id.toString() !== data.fileId,
          ),
        },
      };
    case constants.DIVORCES_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.DIVORCES_ON_DELETE_SUCCEEDED:
    case constants.DIVORCES_ON_SAVE_SUCCEEDED:
    case constants.DIVORCES_ON_DELETE_FAILED:
    case constants.DIVORCES_ON_DELETE_FILE_FAILED:
    case constants.DIVORCES_ON_GET_ALL_FAILED:
    case constants.DIVORCES_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.DIVORCES_ON_GET_FORM_FAILED:
      return {
        ...state,
        idCardTypes: {},
        loading: false,
      };
    case constants.DIVORCES_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default divorcesReducer;
